export const JOBS_ROUTES = {
  IT_CH: 'https://jobs.geberit.com/Jobs/All?lang=ita',
  FR_CH: 'https://jobs.geberit.com/Jobs/All?lang=fre',
  DE_DE: 'https://jobs.geberit.com/Jobs/All?lang=ger',
  DE_CH: 'https://jobs.geberit.com/Jobs/All?lang=ger',
  DE_AT: 'https://jobs.geberit.com/Jobs/All?lang=ger',
  EN_UK: 'https://jobs.geberit.com/Jobs/All?lang=eng',
  NL_NL: 'https://jobs.geberit.com/Jobs/All?lang=eng',
};
